import type { FaireRetailerEntity } from "../../entity_types/retailer";

export const r_9rhufegspe: FaireRetailerEntity = {
  token: "r_9rhufegspe",
  type: "retailer",
  name: "Retailer",
  country: "USA",
  ownerUserToken: "u_4sur91pkmh",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:21:02.051Z",
    importedBy: "entity-db-cli",
  },
  themeTokens: [
    "board_demo_r_9rhufegspe_hero_mothers_day",
    "board_demo_r_9rhufegspe_thi_68aa6283c9",
    "board_demo_r_9rhufegspe_thi_a33d4f0cb9",
    "board_demo_r_9rhufegspe_thi_d2d140e565",
    "board_demo_r_9rhufegspe_thi_e7ffdd35bd",
    "board_demo_r_9rhufegspe_thi_2df2e56285",
    "board_demo_r_9rhufegspe_thi_e1a30c380d",
    "board_demo_r_9rhufegspe_thi_82406891df",
    "board_demo_r_9rhufegspe_thi_f5e67f7f3a",
    "board_demo_r_9rhufegspe_thi_c83dec056f",
  ],
};
